export { Autocomplete } from "@mantine/core";
export type { AutocompleteProps } from "@mantine/core";
export { getAutocompleteOverrides } from "./Autocomplete.styled";
